<template>
  <main loadingactive="[object Object]">
    <div class="section-group">
      <div class="page-content d-flex align-items-center justify-content-center">
        <div class="row w-100 mx-0 auth-page">
          <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center"><img src="../assets/img/404.svg"
              alt="404" class="img-fluid mb-2">
            <h1 class="font-weight-bold mb-22 mt-2 tx-80 text-muted">404</h1>
            <h4 class="mb-2">Page Not Found</h4>
            <h6 class="text-muted mb-3 text-center">Oopps!! The page you were looking for doesn't exist.</h6>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Not Found",
};
</script>
